/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
const a=1e-6,t=Math.random,e=Math.PI/180,n=180/Math.PI;function s(a){return a*e}function o(a){return a*n}function r(t,e){return Math.abs(t-e)<=a*Math.max(1,Math.abs(t),Math.abs(e))}const u=Object.freeze({__proto__:null,EPSILON:a,RANDOM:t,toRadian:s,toDegree:o,equals:r});export{a as E,t as R,o as a,u as c,r as e,s as t};
